jQuery(document).ready(function () {

  // --- Existing sample button logic (leave as-is) ---
  jQuery(document).on('click', '.button-sample', function (e) {
    e.preventDefault();
    setTimeout(function () {
      jQuery('#add-sample-button').click();
    }, 150);
    jQuery(this).toggleClass('sample__button--already-in-cart');
    jQuery(this).text("Added to cart!");
  });

  jQuery('.sample__button--add').click(function () {
    jQuery(this).toggleClass('sample__button--already-in-cart');
    jQuery(this).text("Added to cart!");
  });

  jQuery(document).one('click', '.sample__button--add', function (e) {
    e.preventDefault();
    var $count = jQuery('.site-header-cart--count');
    var current = Number($count.attr('data-header-cart-count')) || 0;

    if (current < 1) {
      $count.attr('data-header-cart-count', 1);
      $count.css('opacity', 1);
    } else {
      $count.attr('data-header-cart-count', current + 1);
    }

    jQuery('.sample__modal--overlay').fadeIn();
    setTimeout(function () {
      jQuery('.sample__modal--overlay').fadeOut();
    }, 3000);
  });

  jQuery(document).on('click', '.sample__modal--overlay', function (e) {
    e.preventDefault();
    jQuery(this).fadeOut();
  });

  // --- Quickshop modal logic (unchanged) ---
  jQuery(document).one('click', '.button__quickshop--open', function (e) {
    e.preventDefault();
    jQuery('.quickshop__modal--overlay').remove();
    jQuery('body').prepend('<div class="quickshop__modal--overlay"><div class="quickshop__modal--inner"><div class="quickshop__modal--close">✕</div></div></div>');
    jQuery('.quickshop__modal--overlay').fadeIn();
    jQuery.get(jQuery(this).attr('data-product-url'), function (data) {
      jQuery('.quickshop__modal--inner').append(data);
    });
  });

  jQuery(document).on('click', '.quickshop__modal--overlay, .quickshop__modal--close', function (e) {
    if (e.target == this) {
      jQuery('.quickshop__modal--overlay').fadeOut();
      setTimeout(function () {
        jQuery('.quickshop__modal--overlay').remove();
      }, 600);
    }
  });

  // --- Accordion logic (unchanged) ---
  jQuery('.product-info__accordion--item').click(function () {
    if (jQuery('.product-info__accordion--trigger', this).hasClass('active')) {
      jQuery('.product-info__accordion--panel', this).slideUp();
      jQuery('.product-info__accordion--trigger').removeClass('active');
    } else {
      jQuery('.product-info__accordion--trigger').removeClass('active');
      jQuery('.product-info__accordion--panel').slideUp();
      jQuery('.product-info__accordion--trigger', this).addClass('active');
      jQuery('.product-info__accordion--panel', this).slideDown();
    }
  });

});

// NOTE: The old block that intercepted ".product-form--atc-button" and called
// "#add-sample-button" has been removed to avoid conflicting with the new
// sample SKU limit + inline onclick logic in product-form.liquid.
